// Static fallback nav — mirrors the backend CURATED_MENU so the header never
// disappears if /api/menu is briefly unavailable (cold start, backend restart).
const c = (h) => `/shop/c/${h}`;

export const NAV_FALLBACK = [
  { title: "Saunas", to: c("saunas"), columns: [
    { heading: "Shop by Type", items: [
      { title: "Infrared Saunas", to: c("infrared-saunas") },
      { title: "Traditional Saunas", to: c("traditional-sauna") },
      { title: "Barrel Saunas", to: c("barrel-saunas") },
      { title: "Cabin Saunas", to: c("cabin-saunas") },
      { title: "Indoor Saunas", to: c("indoor-saunas") },
      { title: "Outdoor Saunas", to: c("outdoor-saunas") },
      { title: "Indoor Sauna Kits", to: c("indoor-sauna-kits") },
      { title: "Outdoor Sauna Kits", to: c("outdoor-sauna-kits") },
    ]},
    { heading: "Shop by Capacity", items: [
      { title: "1 Person", to: c("1-person") },
      { title: "2 People", to: c("2-person") },
      { title: "3 People", to: c("3-people") },
      { title: "4 People", to: c("4-people") },
      { title: "5 People", to: c("5-people") },
      { title: "6 People", to: c("6-people") },
      { title: "8 People", to: c("8-people") },
    ]},
  ]},
  { title: "Sauna Accessories", to: c("sauna-accessories"), columns: [
    { heading: "Accessories", items: [
      { title: "All Accessories", to: c("sauna-accessories") },
    ]},
    { heading: "Sauna Heaters", items: [
      { title: "All Heaters", to: c("sauna-heaters") },
      { title: "Wood Burning Stoves", to: c("wood-burning-stoves") },
      { title: "Sauna Stove Kits", to: c("sauna-stove-kits") },
      { title: "Electric Heaters", to: c("electric-heaters") },
      { title: "Sauna Heater Kits", to: c("sauna-heater-kits") },
      { title: "Heater Controls", to: c("heater-controls") },
    ]},
  ]},
  { title: "Cold Plunges", to: c("cold-plunges"), columns: [] },
  { title: "Hot Tubs", to: c("hot-tubs"), columns: [] },
  { title: "Brands", to: "/brands", columns: [
    { heading: "Shop by Brand", items: [
      { title: "Cozy Heat", to: c("cozy-heat") },
      { title: "Dundalk LeisureCraft", to: c("leisurecraft") },
      { title: "Finnmark Designs", to: c("finnmark-designs") },
      { title: "Harvia", to: c("harvia") },
      { title: "HealthSmart", to: c("healthsmart") },
      { title: "HUKKA", to: c("hukka") },
      { title: "Kohler", to: c("kohler") },
    ]},
    { heading: "\u00a0", items: [
      { title: "KOLO", to: c("kolo") },
      { title: "MandeSpa", to: c("mandespa") },
      { title: "SaunaLife", to: c("saunalife") },
      { title: "Saunum", to: c("saunum") },
      { title: "ThermaSol", to: c("thermasol") },
      { title: "Narvi", to: c("narvi") },
    ]},
  ]},
  { title: "Trade", to: "/commercial", columns: [] },
  { title: "About", to: "/about", columns: [
    { heading: "Company", items: [
      { title: "About Us", to: "/about" },
      { title: "Contact", to: "/contact" },
    ]},
    { heading: "Policies", items: [
      { title: "Privacy Policy", to: "/policies/privacy-policy" },
      { title: "Refund Policy", to: "/policies/refund-policy" },
      { title: "Terms of Service", to: "/policies/terms-of-service" },
    ]},
  ]},
  { title: "Contact", to: "/contact", columns: [] },
];
